module.exports = __webpack_public_path__ + "img/close.904fb6b1.svg";